import { render, staticRenderFns } from "./WorkspacePremium.vue?vue&type=template&id=3ce3d6a6"
import script from "./WorkspacePremium.vue?vue&type=script&lang=js"
export * from "./WorkspacePremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports